import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import Home from './Home';

const LEGACY_JOB_QUERY_KEYS = [
  'q',
  'category',
  'subcategory',
  'subscription',
  'message',
  'hash',
] as const;

const HomeRoute: React.FC = () => {
  const [searchParams] = useSearchParams();
  const isLegacyJobsUrl = LEGACY_JOB_QUERY_KEYS.some((key) =>
    searchParams.has(key)
  );

  if (isLegacyJobsUrl) {
    return (
      <Navigate
        to={{ pathname: '/jobs', search: searchParams.toString() }}
        replace
      />
    );
  }

  return <Home />;
};

export default HomeRoute;
